import { RouteObject } from 'react-router-dom'

import { AbTestsAdd } from 'features/ab-tests/pages/AbTestsAdd'
import { AbTestsEdit } from 'features/ab-tests/pages/AbTestsEdit'
import { AbTestsList } from 'features/ab-tests/pages/AbTestsList'
import AuthorizedRoute from 'providers/router/components/AuthorizedRoute'
import { ROUTES } from 'routes'

export const abTestsRoutes: RouteObject[] = [
  {
    element: (
      <AuthorizedRoute
        access='AbTestsPage-list'
        page={<AbTestsList />}
      />
    ),
    path: ROUTES.AB_TESTS.LIST,
  },
  {
    element: (
      <AuthorizedRoute
        access='AbTestsPage-add'
        page={<AbTestsAdd />}
      />
    ),
    path: ROUTES.AB_TESTS.ADD,
  },
  {
    element: (
      <AuthorizedRoute
        access='AbTestsPage-edit'
        page={<AbTestsEdit />}
      />
    ),
    path: ROUTES.AB_TESTS.EDIT,
  },
]
